function emptyDataset() {
  return { period: null, device: null, regional: null, royalty: null }
}

function initialState() {
  return {
    // ---- Dataset-based storage (primary + comparison) ----
    datasets: {
      primary: emptyDataset(),
      comparison: emptyDataset(),
    },

    isComparisonMode: false,

    periodType: "period", // "day" | "period"
    comparisonPeriodType: "period",

    params: { from_date: "", to_date: "", offset: "" },
    comparisonParams: { from_date: "", to_date: "", offset: "" },

    cityStats: [],
    isStreamingAnalyticsRequested: false,
    streamingRequestStates: {
      period: { loading: false, error: null },
      device: { loading: false, error: null },
      regional: { loading: false, error: null },
      royalty: { loading: false, error: null },
    },
  }
}

let state = initialState()

export { initialState, emptyDataset, state }
